import React from 'react';
import PropTypes from 'prop-types';

// Paragraphs
import ParagraphBanner from '../../paragraphs/ParagraphBanner';
import ParagraphCard from '../../paragraphs/ParagraphCard';
import ParagraphCardList from '../../paragraphs/ParagraphCardList';
import ParagraphDynamic from '../../paragraphs/ParagraphDynamic';
import ParagraphFaq from '../../paragraphs/ParagraphFaq';
import ParagraphHero from '../../paragraphs/ParagraphHero';
import ParagraphText from '../../paragraphs/ParagraphText';

const Content = ({ content, files }) => (
    <>
        {content.map((section, i) => {
            const datakey = `paragraph--section--${section['__typename']}--${i}`;
            switch (section['__typename']) {
                case 'paragraph__banner':
                    return <ParagraphBanner {...section} key={datakey} />;
                case 'paragraph__card':
                    return <ParagraphCard {...section} key={datakey} />;
                case 'paragraph__card_list':
                    return <ParagraphCardList {...section} key={datakey} />;
                case 'paragraph__dynamic':
                    return <ParagraphDynamic {...section} key={datakey} />;
                case 'paragraph__faq':
                    return <ParagraphFaq {...section} key={datakey} />;
                case 'paragraph__hero_media':
                    return <ParagraphHero {...section} key={datakey} />;
                case 'paragraph__text':
                    return (
                        <ParagraphText
                            {...section}
                            key={datakey}
                            files={files}
                        />
                    );
                default:
                    console.log(section['__typename']);
                    return '';
            }
        })}
    </>
);

Content.propTypes = {
    content: PropTypes.array.isRequired,
    files: PropTypes.array.isRequired,
};

export default Content;
